import { useEffect, useState } from 'react'

type PreviewGeneratingProps = {
  isGenerating: boolean
  isComplete: boolean
}

export function PreviewGenerating({ isGenerating, isComplete }: PreviewGeneratingProps) {
  const [elapsedSeconds, setElapsedSeconds] = useState(0)

  useEffect(() => {
    if (!isGenerating) {
      setElapsedSeconds(0)
      return
    }
    const startedAt = Date.now()
    const timer = window.setInterval(() => {
      setElapsedSeconds(Math.floor((Date.now() - startedAt) / 1000))
    }, 1000)
    return () => window.clearInterval(timer)
  }, [isGenerating])

  const elapsed =
    elapsedSeconds < 60
      ? `${elapsedSeconds}s elapsed`
      : `${Math.floor(elapsedSeconds / 60)}m ${elapsedSeconds % 60}s elapsed`
  const statusLabel = isComplete ? 'Preview ready.' : 'Creating your optional studio image…'

  return (
    <div className="preview-generating-wrap">
      <div className="preview-generating">
        <svg className="gen-spinner" viewBox="0 0 32 32" aria-hidden="true">
          <circle cx="16" cy="16" r="12" />
        </svg>
        <div className="gen-text-col">
          <p className="gen-label">Rendering</p>
          <p className="gen-status">{statusLabel}</p>
          <p className="gen-hint">
            This usually takes 2–3 minutes. You can scroll and browse parts while you wait.
          </p>
        </div>
      </div>
      <div className="gen-progress-wrap">
        <div
          className="gen-progress-track"
          role="progressbar"
          aria-label="Studio preview rendering"
        >
          <div className="gen-progress-fill" />
        </div>
        <span className="gen-progress-pct">{elapsed}</span>
      </div>
    </div>
  )
}
